import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Tab, Tabs } from 'react-bootstrap';
import { BackButton, Box, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import {
  endCampaign,
  getCampaign,
  updateCampaignBannerMetadata,
} from '../redux/campaignActions';
import CampaignDetails from '../components/CampaignDetails/CampaignDetails';

const CampaignsShowContainer = ({
  onGetCampaign,
  onEndCampaign,
  onUpdateCampaignBanner,
  params: { id },
}) => {
  useEffect(
    () => {
      onGetCampaign(id, ['channels', 'product'], 'fields[channels]=id,channel_type,name');
    },
    [onGetCampaign, id],
  );

  const refreshCampaign = () => {
    onGetCampaign(id, ['channels', 'product'], 'fields[channels]=id,channel_type,name');
  };
  const endCampaign = () => {
    onEndCampaign(id);
  };

  const updateCampaignBanner = (values) => {
    return Promise.resolve(onUpdateCampaignBanner(values)).then(() => {
      return refreshCampaign(id);
    });
  };

  //&fields[products/schemes]=id,name,version`
  const resource = useSelector((state) => state.campaign.resources?.[id]);

  const campaignType = resource?.data?.attributes?.campaign_type;

  if (!resource) {
    return (
      <InternalContainer title={'Campaigns'} buttons={<BackButton />}>
        <Loader />
      </InternalContainer>

    );
  }

  return (
    <InternalContainer title={'Campaigns'} buttons={<BackButton />}>
      <Tabs id="organisation-tabs" unmountOnExit={true}>
        <Tab eventKey={1} title={campaignType}>
          <Box>
            <CampaignDetails
              resource={resource}
              onEndCampaign={endCampaign}
              onUpdateCampaignBanner={updateCampaignBanner}
              //onRefreshCampaign={refreshCampaign}
            />
          </Box>
        </Tab>
      </Tabs>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onGetCampaign: getCampaign,
    onEndCampaign: endCampaign,
    onUpdateCampaignBanner: updateCampaignBannerMetadata,
  },

)(CampaignsShowContainer);
